<template>
  <div>
    <training-member-toolbar />
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header :title="$t('trainings.apply_title')" :iconName="'file-earmark-text'" />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert" variant="danger" dismissible>
          {{ error.message }}
        </b-alert>
        <b-overlay :show="isLoading" spinner-variant="primary" rounded="sm">
          <template v-if="this.showApplyForm">
            <div class="card mb-3">
              <b-card-header class="esep-blue-bg text-light">
                <h6 class="float-left font-weight-bold">{{ $t('participation.apply') }}</h6>
              </b-card-header>
              <b-card-body>
                <b-row>
                  <b-form-group :label="$t('training-add.id')" label-for="member-type" label-align="left" class="col-2">
                    <b-form-input v-model="participation.training.id" disabled>
                    </b-form-input>

                  </b-form-group>
                  <b-form-group :label="$t('parametrics.moduleTitle')" label-for="member-type" label-align="left"
                    class="col-4">
                    <b-form-input v-model="trainingTitle" disabled>
                    </b-form-input>

                  </b-form-group>


                </b-row>
                <b-row>
                  <b-form-group id="input-application-type-label" :label="$t('participation.type')"
                    label-for="member-type" label-align="left" class="col-2">
                    <b-form-select id="member-type" v-model="memberType"
                      :options="memberTypes.filter(t => t.requiresPlan === participation.training.module.requiresPlan)"
                      @input="clearMember" :disabled="!canSelectOthers && !isAdmin">
                    </b-form-select>

                  </b-form-group>
                  <b-form-group id="input-application-member-label" :label="$t('participation.name')"
                    label-for="input-application-member" label-align="left" class="col-8">
                    <v-select :options="activeMembers" @search="getMember"
                      :placeholder="$t('participation.newMemberPlaceholder')" v-model="participation.member"
                      :filterable="false" :disabled="!canSelectOthers && !isAdmin">
                      <template slot="option" slot-scope="option">
                        <div class="d-center"
                          :style="option.lastYearCensus !== null && option.lastYearCensus < currentCensus ? 'color: gray; font-style: italic;' : ''">
                          {{ option.surName }} {{ option.firstName }}
                        </div>
                      </template>

                      <template slot="no-options">
                        {{ $t('participation.noMembersFound') }}
                      </template>

                    </v-select>
                  </b-form-group>


                </b-row>

                <b-alert
                  v-if="participation.member !== null && participation.member.lastYearCensus === null && participation.member.lastYearCensus < this.currentCensus"
                  show variant="warning"><b-icon icon="exclamation-diamond" /> Δεν έχει γίνει απογραφή για το τρέχον
                  έτος.</b-alert>

              </b-card-body>
              <b-card-footer>
                <div class="float-left mt-2">
                  <b-button @click="submitParticipationForm" variant="success" class="mr-1"
                    :disabled="(participation.member == null || participation.training == null)">{{ $t("common.submit")
                    }}</b-button>
                  <b-button @click="hideParticipationForm" variant="danger">{{
                      $t("common.cancel")
                  }}</b-button>
                </div>
              </b-card-footer>
            </div>
          </template>
        </b-overlay>
        <template>
          <trainings-filter @refresh-list="refreshList" :filters="this.filters" />
          <hr />
        </template>
        <b-skeleton-wrapper :loading="trainings == null">
          <template #loading>
            <trainings-table-skeleton />
          </template>
          <template>
            <trainings-table :trainings="trainings" :trainingsCount="trainingsCount"
              @pagination-changed='paginationChanged' @sorting-changed='sortingChanged' :actions="actions"
              @show-apply-training="trainingApplicationFn" />
          </template>
        </b-skeleton-wrapper>
      </b-card-body>

    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingsTable from '../../components/trainings/trainingsTable.vue';
import TrainingsFilter from '../../components/trainings/trainingsFilter.vue';
import TrainingsTableSkeleton from '../../components/trainings/trainingsTableSkeleton.vue';
import axios from "axios";
import TrainingMemberToolbar from "@/components/TrainingMemberToolbar";
// import {hasRole} from "esep/src/services/utils";
// import {roles, routes} from "esep/src/services/routing.service.js";

export default {
  computed: {
    trainingTitle() {
      return `[${this.participation.training.activityNo}] ${this.participation.training.module.title}`
    },
    hasPlan() {
      return this.userInfo.orgMember.type ? ['LEADER', 'ROVER'].includes(this.userInfo.orgMember.type) : true;
    },
    accessibleUnits: function () {
      let units = [];
      for (let i = 0; i < this.$store.state.usersAccessibleUnits.length; i++) {
        const orgUnitName = this.$store.state.usersAccessibleUnits[i].name;
        const orgUnitId = this.$store.state.usersAccessibleUnits[i].id;
        const orgUnitType = this.$store.state.usersAccessibleUnits[i].type;
        const unit = { label: orgUnitName, id: orgUnitId, type: orgUnitType };
        units.push(unit);
      }
      return units;
    },
    isAdmin() {
      let isAdmin = false;
      let userInfo = this.$store.state.userInfo
      for (let i = 0; i < userInfo.roles?.length; i++) {
        if (userInfo.roles[i].name == "ADMIN" || userInfo.roles[i].name == 'TRAINING_ADMIN') {
          isAdmin = true;
        }
      }
      return isAdmin;
    },
    isMod() {
      let isMod = false;
      let userInfo = this.$store.state.userInfo

      for (let i = 0; i < userInfo.roles?.length; i++) {
        if (userInfo.roles[i].name == "TRAIN_MOD") {
          isMod = true;
        }
      }
      return isMod;
    },
    isTrainer() {
      let isTrainer = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles?.length; i++) {
        if (userInfo.roles[i].name == "TRAINER") {
          isTrainer = true;
        }
      }
      return isTrainer;
    }
  },
  components: {
    TrainingMemberToolbar,
    CardHeader,
    TrainingsTable,
    TrainingsFilter,
    TrainingsTableSkeleton
  },
  mounted() {
    if ("moduleId" in this.$route.query) {
      this.criteria.moduleId = this.$route.query.moduleId;
    }
    if ("activityId" in this.$route.query) {
      trainingService.getAnnouncementById(this.$route.query.activityId).then(
          (response) => {
            this.trainingApplicationFn(response.data);
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
      )
    }
    trainingService.getCurrentCensusPeriod().then(
      (response) => {
        this.currentCensus = response.data.yearCensus;
      },
      (error) => {
        this.handleError(handleApiError(error))
      }
    );
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        // if (!hasRole(this.userInfo, roles.training.participation)){
        //   location.replace(routes.nothing);
        // }
        this.$store.state.userInfo = this.userInfo;
        if (!this.isAdmin && !this.isMod && this.isTrainer) {
          this.criteria.status = null;
        } else {
          // if(this.$store.state.latestActivityStatus) {
          //   this.criteria.status = this.$store.state.latestActivityStatus;
          // }
        }
        // if (this.isAdmin){
        //   this.depositTypes.push({ value: "FINANCE_DEP", text: this.$t('paymentTypeEnums.FINANCE_DEP'), enabled: true },);
        // }
        this.participation.member = this.userInfo.orgMember;
        this.memberType = this.userInfo.orgMember.type;

        trainingService.getUsersPermissions(this.username, false, this.userInfo.orgMember.orgUnit.id, 'VIEW_UNIT').then(
          (response) => {
            this.canSelectOthers = response.data.VIEW_UNIT?.length > 0;
            this.getActivities(this.criteria);
            this.getMember("", function () { return false; }, this.userInfo.orgMember.orgUnit.id);
            this.userInfo.orgMember.label = `${this.userInfo.orgMember.surName} ${this.userInfo.orgMember.firstName} (${this.userInfo.orgMember.id})`;

          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
        );

      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  data() {
    return {
      actions: {
        view: false,
        apply: true
      },
      canSelectOthers: false,
      filters: {
        status: false,
        date: true,
        search: true,
        modules: true
      },
      currentCensus: 1908,
      depositTypes: [
        { value: "RF_CODE", text: this.$t('paymentTypeEnums.RF_CODE'), enabled: true },
        { value: "IN_PERSON", text: this.$t('paymentTypeEnums.IN_PERSON'), enabled: true },
        { value: "ISLAND_DISCOUNT", text: this.$t('paymentTypeEnums.ISLAND_DISCOUNT'), enabled: true },
        { value: "BANK", text: this.$t('paymentTypeEnums.BANK'), enabled: true },
        { value: "FINANCE_DEP", text: this.$t('paymentTypeEnums.FINANCE_DEP'), enabled: true },
        { value: "NONE", text: this.$t('paymentTypeEnums.NONE'), enabled: false }
      ],
      activeMembers: [],
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      trainings: null,
      trainingsCount: null,
      showApplyForm: false,
      depositDisabled: false,
      criteria: {
        limit: null,
        pageNo: null,
        search: null,
        status: 'SCHEDULED',
        startDate: null,
        endDate: null
      },
      participation: {
        member: null,
        paymentType: { value: "NONE", text: this.$t('paymentTypeEnums.NONE') },
        activity: null,
        training: null,
        rfCode: null
      },
      cancelSource: null,
      memberType: null,
      memberTypes: [
        { text: 'Βαθμοφόρος', value: 'LEADER', requiresPlan: true },
        { text: 'Μέλος Προσκοπικού Δικτύου', value: 'ROVER', requiresPlan: true },
        { text: 'Μέλος ΕΚΣ', value: 'SUPPORT', requiresPlan: false },
        { text: 'Παλαιός Πρόσκοπος', value: 'OLD_SCOUT', requiresPlan: false },
      ],
      isLoading: false
    }
  },
  methods: {
    clearMember() {
      this.participation.member = null;
      this.getMember("", function () { return false; }, this.userInfo.orgMember.orgUnit.id);
    },
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length > 0;
    },
    trainingApplicationFn(training) {
      this.participation.training = training;

      this.memberType = this.canSelectOthers ? this.memberTypes.find(t => t.requiresPlan === training.module.requiresPlan)?.value : this.memberTypes.find(t => t.value === this.userInfo.orgMember.type)?.value;
      this.getMember("", function () { return false; }, this.userInfo.orgMember.orgUnit.id);
      this.participation.member = this.memberType === this.participation.member?.type ? this.participation.member : null;

      if (training.module.billMethod.rules[0].billingValue > 0) {
        this.participation.paymentType = this.participation.training.paymentTypes[0];
      } else {
        this.participation.paymentType = "NONE";
        this.depositDisabled = true;
      }
      this.showApplyForm = true;
      window.scrollTo(0, 0);
    },
    refreshList(criteria) {
      this.$store.state.pagination = null;
      this.$store.state.sortBy = null;
      this.getActivities(criteria);
    },
    getMember(search, loading, unitId = null) {
      // We do that escape because when an option is selected, search resets and triggers this method again with
      // search=null, ie returning all accessible members
      if (search.length === 0 && unitId === null) {
        return;
      }

      loading(true);
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source()
      trainingService.getMembersByCriteria(unitId ? [unitId] : null, 'REGISTERED', search, null, [this.memberType], this.cancelSource.token).then(
        (response) => {
          this.activeMembers = response.data;
          this.activeMembers.map(function (e) {
            e.label = `${e.surName} ${e.firstName} (${e.id})`;
          });

          loading(false);
          this.cancelSource = null;
        }, (error) => {
          if (error.message === 'cancel') return;
          let errorMessage = handleApiError(error);
          loading(false);
          this.handleError(errorMessage);
        }
      );
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('cancel');
      }
    },
    generateRF() {
      if (this.participation.member && this.participation.training) {
        trainingService.generateRF(this.participation.training.id, this.participation.member.id, this.participation.paymentType).then(
          (response) => {
            this.participation.rfCode = response.data.rfCode;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            errorMessage = errorMessage.filter(error => error.code !== 'ACTIVITY_NO_COST');
            this.handleError(errorMessage);
          }
        )
      }
    },
    getActivities(criteria) {
      this.trainings = null;
      if (criteria.limit == null) {
        criteria.limit = 10;
      }
      if (criteria.pageNo == null) {
        criteria.pageNo = 0;
      }
      this.criteria = criteria;
      this.trainingsCount = null;
      trainingService.getAnnouncements(criteria, this.canSelectOthers ? null : this.hasPlan).then(
        (response) => {
          this.criteria.moduleId = null;
          this.trainingsCount = parseInt(response.headers.itemtotal);
          this.trainings = response.data;
        },
        (error) => {
          this.trainings = [];
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    paginationChanged(pagination) {
      this.criteria.limit = pagination.perPage;
      this.criteria.pageNo = pagination.currentPage - 1;
      this.getActivities(this.criteria);
    },
    sortingChanged(sorting) {
      this.criteria.orderby = sorting;
      this.getActivities(this.criteria);
    },
    hideParticipationForm() {
      this.resetParticipation();
      this.showApplyForm = false;
    },
    resetParticipation() {
      this.participation = {
        member: this.canSelectOthers ? this.participation.member : this.userInfo.orgMember,
        paymentType: { value: "NONE", text: this.$t('paymentTypeEnums.NONE') },
        activity: null,
        training: null,
        rfCode: null
      };
    },
    submitParticipationForm() {
      this.isLoading = true;
      this.participation.activity = this.participation.training;
      trainingService.createParticipation(this.participation).then(
        () => {
          this.resetParticipation();
          this.showApplyForm = false;
          this.popSuccessAlert = true;
          this.successMessage = "Επιτυχής Δήλωση";
          this.isLoading = false;
        },
        (error) => {
          this.showApplyForm = false;
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
          this.isLoading = false;
        }
      )
    }

  }
}
</script>
